/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CondizioneAltroCasoDTO } from './condizione-altro-caso-dto';


export interface AltroCasoTariffarioDTO { 
    costo_pasto?: number;
    costo_pasto_multifiglio?: number;
    prevale_sulle_fasce?: boolean;
    la_tua?: boolean;
    condizioni?: Array<CondizioneAltroCasoDTO>;
}

